import { render, staticRenderFns } from "./versionHighlightMobile.vue?vue&type=template&id=5068bb01&scoped=true&"
import script from "./versionHighlightMobile.vue?vue&type=script&lang=js&"
export * from "./versionHighlightMobile.vue?vue&type=script&lang=js&"
import style0 from "./versionHighlightMobile.vue?vue&type=style&index=0&id=5068bb01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5068bb01",
  null
  
)

export default component.exports